import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '../views/digital-base/images/data-list-icon/vector.svg';
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  class: "text"
};
const _hoisted_3 = {
  class: "operate"
};
const _hoisted_4 = {
  class: "file-list"
};
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  class: "text text-exceeded"
};
const _hoisted_7 = {
  class: "size"
};
const _hoisted_8 = {
  key: 1,
  class: "msg"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 2
};
const _hoisted_12 = {
  class: "cancel"
};
import { Close, Minus } from '@element-plus/icons-vue';
import { countMd5, formatFileSize } from '@/utils/file';
import { dynamicChunksInit, dynamicChunksUpload } from '@/api/upload';
import { useUploadFileChunksStore } from '@/stores/useUploadFileChunksStore';
import DragDirective from '@/directives/drag';

import { ref, computed, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
export default /*@__PURE__*/_defineComponent({
  __name: 'FragmentUpload',
  setup(__props) {
    const fileList = ref([]);
    const isMinimize = ref(false);
    const fileChunkSize = ref(15 * 1024 * 1024);
    const chunkConcurrencyNum = ref(5);
    const isShowGlobalUploader = ref(false);
    const uploadFileChunks = useUploadFileChunksStore();
    const vDrag = DragDirective;
    const uploadedNum = computed(() => {
      const uploadedFileLength = fileList.value.length && fileList.value.filter(item => item.uploadFail || item.uploadCancel || item.uploadCompleted).length;
      return uploadedFileLength || 0;
    });
    watch(() => uploadFileChunks.uploadFileChunksList, newVal => {
      newVal.forEach(async item => {
        try {
          // 文件MD5取第一片生成即可，生成整个文件的MD5时间长，文件太大会导致页面卡顿
          const fileMd5 = await countMd5(item.file.raw.slice(0, fileChunkSize.value));
          // 取文件名后缀作为文件类型传给后端
          const fileNameSplit = item.file.name.split('.');
          const srcFileSuffix = fileNameSplit[fileNameSplit.length - 1];
          // 分片上传初始化
          const {
            destFilename,
            uploadedChunks,
            uploadToken,
            uploadId
          } = await dynamicChunksInit({
            srcFileSuffix,
            srcFileName: item.file.name,
            srcFileSize: item.file.size,
            chunkSize: fileChunkSize.value,
            srcFileMd5: fileMd5,
            extParam: item.extParam,
            autoDecompress: item.autoDecompress
          });
          // 过滤正在上传的文件
          const findUploadFileIndex = fileList.value.findIndex(item => item.uploadToken === uploadToken && !item.uploadCancel && !item.uploadFail && !item.uploadCompleted);
          if (findUploadFileIndex !== -1) return ElMessage.error('文件正在上传中!');
          // 文件最大分片数
          const allChunksLength = Math.ceil(item.file.size / fileChunkSize.value);
          // 全部分片数组
          const allChunksList = [];
          for (let i = 0; i < allChunksLength; i++) {
            allChunksList.push(i);
          }
          // 对比全部分片和已分片的数组，计算出需要上传分片
          const needUploadChunksList = computedArrDifference(allChunksList, uploadedChunks);
          // saveParam 是保存文件时需要的参数，从 Pinia 中传递过来
          item.saveParam.ossPath = destFilename;
          item.saveParam.uploadId = uploadId;
          fileList.value.push({
            ...item,
            name: item.file.name,
            size: item.file.size,
            uploadToken,
            uploadCancel: false,
            uploadFail: false,
            uploadCompleted: false,
            needUploadChunksList,
            allChunksLength,
            uploadProgress: Number((uploadedChunks.length / allChunksLength * 100).toFixed(0))
          });
          if (needUploadChunksList.length === 0) {
            // 如果没有需要上传的分片，直接保存文件
            await handleSaveFile(item.saveApi, item.saveParam);
            fileList.value[fileList.value.length - 1].uploadCompleted = true;
          } else {
            // 初始化完成，开始分片上传
            handleFileChunkUpload(fileList.value.length - 1);
          }
          uploadFileChunks.setUploadFileChunksList([]);
        } catch (error) {
          console.error('分片上传初始化失败: ', error);
          uploadFileChunks.setUploadFileChunksList([]);
          // ElMessage.error('分片上传初始化失败，请检查文件或网络连接');
        }
      });
    });
    // 切片文件上传逻辑
    const handleFileChunkUpload = async fileIndex => {
      isShowGlobalUploader.value = true;
      const {
        file,
        uploadToken,
        needUploadChunksList,
        allChunksLength,
        saveParam,
        saveApi
      } = fileList.value[fileIndex];
      // 初始化本次分片上传数量，上传完成一片 +1 即可
      let uploadedChunksNum = 0;
      // 本次需要上传的分片数量
      const needUploadChunksNum = needUploadChunksList.length;
      // 起始上传数，主要处理同时上传数大于需要上传数导致的异常
      const startChunkNum = chunkConcurrencyNum.value > needUploadChunksNum ? needUploadChunksNum : chunkConcurrencyNum.value;
      // 开始上传
      for (let i = startChunkNum; uploadedChunksNum < needUploadChunksNum; i += chunkConcurrencyNum.value) {
        // 当上传的数量大于需要上传总数时，进行处理
        if (i > needUploadChunksNum) {
          i = needUploadChunksNum;
        }
        // 弹窗关闭时跳出循环
        if (!isShowGlobalUploader.value) break;
        // 上传错误时跳出循环，终止上传
        const {
          uploadFail,
          uploadCancel,
          uploadCompleted
        } = fileList.value[fileIndex];
        if (uploadFail || uploadCancel || uploadCompleted) break;
        // 同时上传分片列表
        const axiosArray = [];
        // 切片上传合并至数组
        for (let chunk = uploadedChunksNum; chunk < i; chunk++) {
          // 从需要上传列表中获取当前上传切片数
          const chunkIndex = needUploadChunksList[chunk];
          const formData = new FormData();
          formData.append('file', file.raw.slice(chunkIndex * fileChunkSize.value, (chunkIndex + 1) * fileChunkSize.value));
          formData.append('uploadToken', uploadToken);
          formData.append('chunkIndex', String(chunkIndex));
          axiosArray.push(dynamicChunksUpload(formData));
          uploadedChunksNum++;
        }
        try {
          await Promise.all(axiosArray);
          const fileUploadFail = false;
          // 判断是否有上传失败的切片，有则取消上传
          if (!fileUploadFail) {
            fileList.value[fileIndex].uploadProgress = Math.ceil(uploadedChunksNum / allChunksLength * 100);
            // 上传到100%的时候保存文件
            if (uploadedChunksNum === needUploadChunksNum) {
              try {
                // let saveFileRes =
                await handleSaveFile(saveApi, saveParam);
                // this.setFileChunkSaveFileRes(saveFileRes);
                // 上传完成
                fileList.value[fileIndex].uploadCompleted = true;
              } catch {
                fileList.value[fileIndex].uploadFail = true;
                fileList.value[fileIndex].uploadFailMsg = '上传失败';
              }
            }
          } else {
            fileList.value[fileIndex].uploadFail = true;
            fileList.value[fileIndex].uploadFailMsg = '上传失败';
          }
        } catch (error) {
          // 切片数组上传结果
          console.log('e: ', error);
          fileList.value[fileIndex].uploadFail = true;
          fileList.value[fileIndex].uploadFailMsg = '上传失败';
        }
        // 文件上传弹窗关闭后清空文件列表
        if (!isShowGlobalUploader.value) {
          fileList.value = [];
        }
      }
    };
    const handleSaveFile = async (saveAPi, saveParams) => {
      return await saveAPi(saveParams);
    };
    const handleCloseSingle = uploadToken => {
      ElMessageBox.confirm('此操作将终止该文件上传, 是否继续?', '提示', {
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        const index = fileList.value.findIndex(item => item.uploadToken === uploadToken);
        if (index !== -1) {
          fileList.value[index].uploadCancel = true;
          fileList.value[index].uploadCompleted = false;
          fileList.value[index].uploadFail = false;
          fileList.value[index].uploadFailMsg = '已取消上传';
        }
      }).catch(() => {
        console.log('取消删除');
      });
    };
    // 关闭分片上传窗口
    const handleClose = () => {
      if (uploadedNum.value < fileList.value.length) {
        ElMessageBox.confirm('此操作将终止所有文件上传, 是否继续?', '提示', {
          showCancelButton: true,
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        }).then(() => {
          isShowGlobalUploader.value = false;
          fileList.value = [];
          ElMessage.success('所有文件上传已终止');
        }).catch(() => {
          console.log('取消删除');
        });
      } else {
        isShowGlobalUploader.value = false;
        fileList.value = [];
      }
    };
    // 获取未上传的分片列表
    const computedArrDifference = (arr1, arr2) => {
      return arr1.concat(arr2).filter(function (value, i, arr) {
        return arr.indexOf(value) === arr.lastIndexOf(value);
      });
    };
    // 最小化、打开分片上传窗口
    const handleMinimize = () => {
      isMinimize.value = !isMinimize.value;
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_progress = _resolveComponent("el-progress");
      return _unref(isShowGlobalUploader) ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["fragment-upload", {
          'fragment-upload--minimize': _unref(isMinimize)
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, "文件上传（" + _toDisplayString(_unref(uploadedNum)) + "/" + _toDisplayString(_unref(fileList)?.length || 0) + "）", 1), _createElementVNode("div", _hoisted_3, [!_unref(isMinimize) ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = $event => handleMinimize())
      }, {
        default: _withCtx(() => [_createVNode(_unref(Minus))]),
        _: 1
      })) : (_openBlock(), _createElementBlock("i", {
        key: 1,
        class: "icon-zoom-out",
        onClick: _cache[1] || (_cache[1] = $event => handleMinimize())
      })), _createVNode(_component_el_icon, {
        onClick: handleClose
      }, {
        default: _withCtx(() => [_createVNode(_unref(Close))]),
        _: 1
      })])]), _withDirectives(_createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "title"
      }, "文件", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fileList), item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.uploadToken,
          class: _normalizeClass(["list-item", {
            'list-item-error': item.uploadCancel || item.uploadFail
          }])
        }, [_createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(formatFileSize)(item.size)), 1), !item.uploadFail && !item.uploadCancel && !item.uploadCompleted ? (_openBlock(), _createBlock(_component_el_progress, {
          key: 0,
          percentage: item.uploadProgress
        }, null, 8, ["percentage"])) : _createCommentVNode("", true), item.uploadFail || item.uploadCancel || item.uploadCompleted ? (_openBlock(), _createElementBlock("div", _hoisted_8, [item.uploadFail ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.uploadFailMsg), 1)) : item.uploadCancel ? (_openBlock(), _createElementBlock("span", _hoisted_10, "已取消上传")) : item.uploadCompleted ? (_openBlock(), _createElementBlock("span", _hoisted_11, "上传完成")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [!item.uploadFail && !item.uploadCancel && !item.uploadCompleted ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          onClick: $event => handleCloseSingle(item.uploadToken)
        }, {
          default: _withCtx(() => [_createVNode(_unref(Close))]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)])], 2);
      }), 128))], 512), [[_vShow, !_unref(isMinimize)]])], 2)), [[_unref(vDrag)]]) : _createCommentVNode("", true);
    };
  }
});